<template>
  <div>
    <div
      id="scroll-to-accessories"
      class="static-button scroll-to-accessories unvisible"
      @click="scrollToTop"
    >
      {{ $t('accessories_text') }}
    </div>
    <div
      id="button-to-payment"
      class="static-button button-to-payment unvisible"
    >
      <router-link :to="lang ? '/' + lang + '/checkout' : '/checkout'" class="">
        {{ $t('to-checkout') }}
      </router-link>
      <img src="/img/scroll-to-accessories.png" alt="scroll-to-accessories" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBackToTop',
  data() {
    return {
      lang: '',
    }
  },
  methods: {
    scrollToTop: () => {
      let cartForm = document
        .querySelector('.woocommerce-cart-form')
        .getBoundingClientRect()
      let accessories = document
        .querySelector('#accessories')
        .getBoundingClientRect()
      window.scrollTo({
        top: accessories.top - cartForm.top + 20,
        behavior: 'smooth',
      })
    },
  },
  mounted() {
    let accessories = document
      .querySelector('#accessories')
      .getBoundingClientRect()
    let btn = document.querySelector('#scroll-to-accessories')
    let payment = document.querySelector('#button-to-payment')
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      btn.classList.remove('unvisible')
    }
    window.addEventListener('scroll', () => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (window.scrollY > accessories.top - 180) {
          btn.classList.add('unvisible')
          payment.classList.remove('unvisible')
        } else {
          btn.classList.remove('unvisible')
          payment.classList.add('unvisible')
        }
      } else {
        btn.classList.add('unvisible')
        payment.classList.add('unvisible')
      }
    })
  },
  updated() {
    let accessories = document
      .querySelector('#accessories')
      .getBoundingClientRect()
    let btn = document.querySelector('#scroll-to-accessories')
    let payment = document.querySelector('#button-to-payment')
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      btn.classList.remove('unvisible')
    }
    window.addEventListener('scroll', () => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (window.scrollY > accessories.top - 180) {
          btn.classList.add('unvisible')
          payment.classList.remove('unvisible')
        } else {
          btn.classList.remove('unvisible')
          payment.classList.add('unvisible')
        }
      } else {
        btn.classList.add('unvisible')
        payment.classList.add('unvisible')
      }
    })
  },
}
</script>

<style>
.static-button.button-to-payment {
  margin-bottom: 190px;
}
.static-button.scroll-to-accessories,
.button-to-payment {
  transition: all 0.25s;
  position: fixed;
  bottom: 0;
  right: 0;

  margin: 0 0px 155px 0;
  padding: 5px 8px;

  background-color: #ff4300;
  color: #ffffff;
  border-radius: 5px 0 0 5px;
  z-index: 9999;

  display: flex;
  justify-content: center;
  align-items: center;
}

.static-button.scroll-to-accessories:active {
  padding-top: 5px;
}

.button-to-payment:active {
  padding-bottom: 5px;
}

.static-button.scroll-to-accessories.unvisible,
.button-to-payment.unvisible {
  right: -205px;
}

.button-to-payment a {
  color: #ffffff;
  width: initial;
  white-space: nowrap;
}

.button-to-payment img {
  height: 16px;
  margin: 0px 10px;
  transform: rotate(90deg);
}
</style>
